import IMAGES from "../../../constant/IMAGES";
import {
  borderColor,
  Cell,
  Label,
  primaryText,
  Row,
} from "../../../utils/perpetualCalendar";
import SunLunchIcon from "../IconCustom/sunLunchIcon";
import SunRiseIcon from "../IconCustom/sunRise";
import SunSetIcon from "../IconCustom/sunSet";

const boxClass = (
  isEvenPage: boolean,
  isSunday: boolean,
  hasEvents: boolean,
) => {
  const isRed = isSunday || hasEvents;

  const borderColor = isRed
    ? "border-[#C1AC96]"
    : isEvenPage
      ? " border-blue-900"
      : "border-[#266914]";

  return `border-2 p-2 rounded-lg mt-4 ${borderColor}`;
};

type CalendarContentProps = {
  exportMode?: boolean;
  detailCalendar: any;
  isLastPage?: boolean;
};

const SAO_TOT = {
  thien_duc: "Thiên Đức",
  thoi_duc: "Thời Đức",
  thien_duc_hop: "Thiên Đức Hợp",
  nguyet_duc: "Nguyệt Đức",
  nguyet_duc_hop: "Nguyệt Đức Hợp",
  thien_hy: "Thiên Hỷ",
  thien_phu: "Thiên Phú",
  thien_quy: "Thiên Quý",
  thien_xa: "Thiên Xá",
  sinh_khi: "Sinh Khí",
  thien_phuc: "Thiên Phúc",
  thien_thanh: "Thiên Thành",
  thien_quan: "Thiên Quan",
  thien_ma: "Thiên Mã",
  thien_tai: "Thiên Tài",
  dia_tai: "Địa Tài",
  nguyet_tai: "Nguyệt Tài",
  nguyet_an: "Nguyệt Ân",
  nguyet_khong: "Nguyệt Không",
  minh_tinh: "Minh Tinh",
  thanh_tam: "Thánh Tâm",
  ngu_phu: "Ngũ Phú",
  loc_kho: "Lộc Khố",
  phuc_sinh: "Phúc Sinh",
  cat_khanh: "Cát Khánh",
  am_duc: "Âm Đức",
  u_vi_tinh: "U Vi Tinh",
  man_duc_tinh: "Mãn Đức Tinh",
  kinh_tam: "Kính Tâm",
  tue_hop: "Tuế Hợp",
  nguyet_giai: "Nguyệt Giải",
  quan_nhat: "Quan Nhật",
  hoat_dieu: "Hoạt Diệu",
  giai_than: "Giải Thần",
  pho_ho: "Phổ Hộ",
  ich_hau: "Ích Hậu",
  tuc_the: "Tục Thế",
  yeu_yen: "Yếu Yên",
  dich_ma: "Dịch Mã",
  tam_hop: "Tam Hợp",
  luc_hop: "Lục Hợp",
  mau_thuong: "Mẫu Thương",
  phuc_hau: "Phúc Hậu",
  dai_hong_sa: "Đại Hồng Sa",
  dan_nhat: "Dân Nhật",
  hoang_an: "Hoàng Ân",
  thanh_long: "Thanh Long",
  minh_duong: "Minh Đường",
  kim_duong: "Kim Đường",
  ngoc_duong: "Ngọc Đường",
  thien_thuy: "Thiên Thụy",
  ngu_hop: "Ngũ Hợp",
  thien_an: "Thiên Ân",
  sat_cong: "Sát Cống",
  truc_tinh: "Trực Tinh",
  nhan_chuyen: "Nhân Chuyên",
  tieu_hao: "Tiểu Hao",
};
const SAO_XAU ={
  thien_cuong: "Thiên Cương",
  thien_lai: "Thiên Lại",
  thien_nguc_thien_hoa: "Thiên Ngục, Thiên Hỏa",
  tieu_hong_sa: "Tiểu Hồng Sa",
  dai_hao: "Đại Hao",
  tieu_hao: "Tiểu Hao",
  nguyet_pha: "Nguyệt Phá",
  kiep_sat: "Kiếp Sát",
  dia_pha: "Địa Phá",
  tho_phu: "Thổ Phủ",
  tho_on: "Thổ Ôn",
  thien_on: "Thiên Ôn",
  thu_tu: "Thụ Tử",
  hoang_vu: "Hoang Vu",
  thien_tac: "Thiên Tặc",
  dia_tac: "Địa Tặc",
  hoa_tai: "Hỏa Tai",
  nguyet_hoa_doc_hoa: "Nguyệt Hỏa, Độc Hỏa",
  nguyet_yem_dai_hoa: "Nguyệt Yếm Đại Họa",
  nguyet_hu: "Nguyệt Hư",
  hoang_sa: "Hoàng Sa",
  luc_bat_thanh: "Lục Bất Thành",
  nhan_cach: "Nhân Cách",
  than_cach: "Thần Cách",
  phi_ma_sat: "Phi Ma Sát",
  ngu_quy: "Ngũ Quỷ",
  bang_tieu_ngoa_ham: "Băng Tiêu Ngọa Hãm",
  ha_khoi_cau_giao: "Hà Khôi, Cẩu Giảo",
  vang_vong: "Vãng Vong",
  cuu_khong: "Cửu Không",
  trung_tang: "Trùng Tang",
  trung_phuc: "Trùng Phục",
  chu_tuoc_hac_dao: "Chu Tước Hắc Đạo",
  bach_ho: "Bạch Hổ",
  huyen_vu: "Huyền Vũ",
  cau_tran: "Câu Trận",
  loi_cong: "Lôi Công",
  co_than: "Cô Thần",
  qua_tu: "Quả Tú",
  sat_chu: "Sát Chủ",
  nguyet_hinh: "Nguyệt Hình",
  toi_chi: "Tội Chỉ",
  nguyet_kien_chuyen_sat: "Nguyệt Kiến Chuyển Sát",
  thien_dia_chinh_chuyen: "Thiên Địa Chính Chuyển",
  thien_dia_chuyen_sat: "Thiên Địa Chuyển Sát",
  lo_ban_sat: "Lỗ Ban Sát",
  phu_dau_sat: "Phủ Đầu Sát",
  tam_tang: "Tam Tang",
  ngu_hu: "Ngũ Hư",
  tho_cam: "Thổ Cấm",
  ly_sang: "Ly Sàng",
  tinh_thoi_co_qua: "Tứ Thời Cô Quả",
  khong_phong: "Không Phòng",
  am_thac: "Âm Thác",
  duong_thac: "Dương Thác",
  quy_khoc: "Quỷ Khốc",
  thien_an: "Thiên Ân",
  sat_cong: "Sát Cống",
  nhan_chuyen: "Nhân Chuyên",
  truc_tinh: "Trực Tinh",
  tu_thoi_dai_mo: "Tứ Thời Đại Mộ",
};

const CONG_VIEC_MAPPING = {
  cung_le: "Cúng lễ",
  cau_phuc: "Cầu phúc",
  cau_tai: "Cầu tài",
  cau_tu: "Cầu tự",
  dong_tho: "Động thổ",
  do_mai: "Đổ mái",
  nhap_trach: "Nhập trạch",
  pha_do: "Phá dỡ",
  sua_chua: "Sửa chữa",
  khai_truong: "Khai trương",
  mo_cua_hang: "Mở cửa hàng",
  dinh_hon: "Đính hôn",
  an_hoi: "Ăn hỏi",
  cuoi_ga: "Cưới gả",
  ky_ket: "Ký kết",
  giao_dich: "Giao dịch",
  nham_chuc: "Nhậm chức",
  chuyen_nha: "Chuyển nhà",
  chuyen_bep: "Chuyển bếp",
  an_tang: "An táng",
  cai_tang: "Cải táng",
  to_tung: "Tố tụng",
  xuat_hanh: "Xuất hành",
  mai_tang: "Mai táng",
  xay_tuong: "xây tường",
  dap_bo: "đắp bờ",
};
const NGAY_HOANGDAO_HACDAO_MAPPING = {
  thanh_long_hoang_dao: "Thanh Long Hoàng Đạo",
  minh_duong_hoang_dao: "Minh Đường Hoàng Đạo",
  kim_quy_hoang_dao: "Kim Quỹ Hoàng Đạo",
  kim_duong_hoang_dao: "Kim Đường Hoàng Đạo",
  ngoc_duong_hoang_dao: "Ngọc Đường Hoàng Đạo",
  tinh_menh_hoang_dao: "Tư Mệnh Hoàng Đạo",
  thien_hinh_hac_dao: "Thiên Hình Hắc Đạo",
  chu_tuoc_hac_dao: "Chu Tước Hắc Đạo",
  bach_ho_hac_dao: "Bạch Hổ Hắc Đạo",
  thien_lao_hac_dao: "Thiên Lao Hắc Đạo",
  nguyen_vu_hac_dao: "Nguyên Vũ Hắc Đạo",
  cau_tran_hac_dao: "Cân Trần Hắc Đạo",
};
const WEEKDAY_MAPPING = {
  thu_hai: "Thứ hai",
  thu_ba: "Thứ ba",
  thu_tu: "Thứ tư",
  thu_nam: "Thứ năm",
  thu_sau: "Thứ sáu",
  thu_bay: "Thứ bảy",
  chu_nhat: "Chủ nhật",
};

//CAN CHI
const CAN_CHI = {
  //CAN
  canh: "Canh",
  tan: "Tân",
  nham: "Nhâm",
  quy: "Quý",
  giap: "Giáp",
  at: "Ất",
  binh: "Bính",
  dinh: "Đinh",
  mau: "Mậu",
  ky: "Kỷ",
  //CHI
  than: "Thân",
  dau: "Dậu",
  tuat: "Tuất",
  hoi: "Hợi",
  tys: "Tý",
  ty: "Tý",
  suu: "Sửu",
  dan: "Dần",
  mao: "Mão",
  thin: "Thìn",
  tyj: "Tỵ",
  ngo: "Ngọ",
  mui: "Mùi",
  //CAN CHI
  giap_tys: "Giáp Tý",
  giap_dan: "Giáp Dần",
  giap_thin: "Giáp Thìn",
  giap_ngo: "Giáp Ngọ",
  giap_than: "Giáp Thân",
  giap_tuat: "Giáp Tuất",
  at_suu: "Ất Sửu",
  at_mao: "Ất Mão",
  at_tyj: "Ất Tỵ",
  at_mui: "Ất Mùi",
  at_dau: "Ất Dậu",
  at_hoi: "Ất Hợi",
  binh_tys: "Bính Tý",
  binh_dan: "Bính Dần",
  binh_thin: "Bính Thìn",
  binh_ngo: "Bính Ngọ",
  binh_than: "Bính Thân",
  binh_tuat: "Bính Tuất",
  dinh_suu: "Đinh Sửu",
  dinh_mao: "Đinh Mão",
  dinh_tyj: "Đinh Tỵ",
  dinh_mui: "Đinh Mùi",
  dinh_dau: "Đinh Dậu",
  dinh_hoi: "Đinh Hợi",
  mau_tys: "Mậu Tý",
  mau_dan: "Mậu Dần",
  mau_thin: "Mậu Thìn",
  mau_ngo: "Mậu Ngọ",
  mau_than: "Mậu Thân",
  mau_tuat: "Mậu Tuất",
  ky_suu: "Kỷ Sửu",
  ky_mao: "Kỷ Mão",
  ky_tyj: "Kỷ Tỵ",
  ky_mui: "Kỷ Mùi",
  ky_dau: "Kỷ Dậu",
  ky_hoi: "Kỷ Hợi",
  canh_tys: "Canh Tý",
  canh_dan: "Canh Dần",
  canh_thin: "Canh Thìn",
  canh_ngo: "Canh Ngọ",
  canh_than: "Canh Thân",
  canh_tuat: "Canh Tuất",
  tan_suu: "Tân Sửu",
  tan_mao: "Tân Mão",
  tan_tyj: "Tân Tỵ",
  tan_mui: "Tân Mùi",
  tan_dau: "Tân Dậu",
  tan_hoi: "Tân Hợi",
  nham_tys: "Nhâm Tý",
  nham_dan: "Nhâm Dần",
  nham_thin: "Nhâm Thìn",
  nham_ngo: "Nhâm Ngọ",
  nham_than: "Nhâm Thân",
  nham_tuat: "Nhâm Tuất",
  quy_suu: "Quý Sửu",
  quy_mao: "Quý Mão",
  quy_tyj: "Quý Tỵ",
  quy_mui: "Quý Mùi",
  quy_dau: "Quý Dậu",
  quy_hoi: "Quý Hợi",
};
//NGU HANH
const NGU_HANH = {
  kim: "Kim",
  moc: "Mộc",
  tho: "Thổ",
  thuy: "Thuỷ",
  hoa: "Hoả",
};

const TIET_KHI = {
  xuan_phan: "Xuân phân", //0:
  thanh_minh: "Thanh minh", //15:
  coc_vu: "Cốc vũ", //30:
  lap_ha: "Lập hạ", //45:
  tieu_man: "Tiểu mãn", //60:
  mang_chung: "Mang chủng", //75:
  ha_chi: "Hạ chí", //90:
  tieu_thu: "Tiểu thử", //105:
  dai_thu: "Đại thử", //120:
  lap_thu: "Lập thu", //135:
  xu_thu: "Xử thử", //150:
  bach_lo: "Bạch lộ", //165:
  thu_phan: "Thu phân", //180:
  han_lo: "Hàn lộ", //195:
  suong_giang: "Sương giáng", //210:
  lap_dong: "Lập đông", //225:
  tieu_tuyet: "Tiểu tuyết", //240:
  dai_tuyet: "Đại tuyết", //255:
  dong_chi: "Đông chí", //270:
  tieu_han: "Tiểu hàn", //285:
  dai_han: "Đại hàn", //300:
  lap_xuan: "Lập xuân", //315:
  vu_thuy: "Vũ thủy", //330:
  kinh_trap: "Kinh trập", //345
};

// TRỰC
const TRUC = {
  truc_kien: "Kiến",
  truc_tru: "Trừ",
  truc_man: "Mãn",
  truc_binh: "Bình",
  truc_dinh: "Định",
  truc_chap: "Chấp",
  truc_pha: "Phá",
  truc_nguy: "Nguy",
  truc_thanh: "Thành",
  truc_thu: "Thu",
  truc_khai: "Khai",
  truc_be: "Bế",
};
//28 TINH/TÚ
const TU = {
  tinh_hu: "Hư",
  tinh_nguy: "Nguy",
  tinh_that: "Thất",
  tinh_bich: "Bích",
  tinh_khue: "Khuê",
  tinh_lau: "Lâu",
  tinh_vij: "Vị",
  tinh_mao: "Mão",
  tinh_tat: "Tất",
  tinh_chuy: "Chủy",
  tinh_sam: "Sâm",
  tinh_tinhr: "Tỉnh",
  tinh_quy: "Quỷ",
  tinh_lieu: "Liễu",
  tinh_tinh: "Tinh",
  tinh_truong: "Trương",
  tinh_duc: "Dực",
  tinh_chan: "Chẩn",
  tinh_giac: "Giác",
  tinh_cang: "Cang",
  tinh_de: "Đê",
  tinh_phong: "Phòng",
  tinh_tam: "Tâm",
  tinh_vix: "Vĩ",
  tinh_co: "Cơ",
  tinh_dau: "Đẩu",
  tinh_nguu: "Ngưu",
  tinh_nu: "Nữ",
};

const BACH_KY = {
  nguyet_ky: "Nguyệt kỵ",
  tam_nuong: "Tam Nương",
  tho_tu: "Thọ Tử",
  sat_chu_am: "Sát Chủ Âm",
  sat_chu_duong: "Sát Chủ Dương",
  vang_vong: "Vãng Vong",
  nguyet_pha: "Nguyệt Phá",
  khong_pham: "Không phạm",
  tue_pha: "Tuế Phá",
};

function extractDMY(dateStr?: string) {
  if (!dateStr) return { day: "--", month: "--", year: "--" };

  // ISO: 2026-05-01 hoặc 2026-05-01T...
  const isoMatch = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch)
    return { day: isoMatch[3], month: isoMatch[2], year: isoMatch[1] };

  // DD/MM/YYYY
  const dmyMatch = dateStr.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
  if (dmyMatch)
    return {
      day: dmyMatch[1].padStart(2, "0"),
      month: dmyMatch[2].padStart(2, "0"),
      year: dmyMatch[3],
    };

  // Fallback: try native Date parsing (may be unreliable for DD/MM/YYYY)
  const dt = new Date(dateStr);
  if (!isNaN(dt.getTime())) {
    return {
      day: String(dt.getDate()).padStart(2, "0"),
      month: String(dt.getMonth() + 1).padStart(2, "0"),
      year: String(dt.getFullYear()),
    };
  }

  // nếu không parse được, trả nguyên chuỗi vào day
  return { day: dateStr, month: "--", year: "--" };
}

export default function CalendarContentPDF({
  exportMode = false,
  detailCalendar,
  isLastPage = false,
}: CalendarContentProps): React.ReactElement {
  const containerClass = "w-full";
  const introClass = exportMode ? "px-6 pt-5 text-lg" : "px-6 pt-4  md:text-lg";
  const titleWrapClass = exportMode
    ? "px-8 pt-4 pb-5 text-center"
    : "px-3 pt-3 pb-4 text-center sm:px-5  md:pt-4 md:pb-5";
  const titleClass = exportMode
    ? "text-[28px]"
    : "text-xl sm:text-2xl md:text-[28px]";
  const bodyWrapClass = exportMode
    ? "relative z-10 px-6 pb-6 leading-[1.2]"
    : "relative z-10 px-2 pb-4 leading-[1.2] sm:px-4 md:px-6 md:pb-6";
  const mediumTextClass = exportMode
    ? "text-lg"
    : "text-base sm:text-base md:text-lg";
  const smallTextClass = exportMode
    ? "text-lg"
    : "text-sm sm:text-base md:text-lg";
  const quoteClass = exportMode
    ? "pt-8 text-center text-xl italic"
    : "pt-6 text-center text-lg italic md:pt-8 md:text-xl";
  const logoClass = exportMode
    ? "w-[340px] object-contain"
    : "w-full object-contain";
  const mapArrayWithObject = (
    arr: string[] | undefined,
    mapping: Record<string, string>,
  ) => {
    if (!Array.isArray(arr) || arr.length === 0) return "--";

    return arr.map((key) => mapping[key] || key).join(", ");
  };

  const title = `Tháng ${detailCalendar?.items[0]?.monthSolar} - Tháng ${mapArrayWithObject([detailCalendar?.items[0]?.thangCan], CAN_CHI)} ${mapArrayWithObject([detailCalendar?.items[0]?.thangChi], CAN_CHI)} - Năm ${mapArrayWithObject([detailCalendar?.items[0]?.namCan], CAN_CHI)} ${mapArrayWithObject([detailCalendar?.items[0]?.namChi], CAN_CHI)}`;

  const renderZodiacIcons = (
    arr?: string | string[],
    isEvenPage?: boolean,
    hasEvents?: boolean,
    isSunday?: boolean,
  ) => {
    const keys = Array.isArray(arr) ? arr : arr ? [arr] : [];

    if (keys.length === 0) return null;

    const ZODIAC_IMAGE_KEY_MAP: Record<string, string> = {
      mao: "mao",
      tyj: "ty",
      tys: "ti",
      ti: "ti",
      ty: "ty",
      suu: "suu",
      dan: "dan",
      thin: "thin",
      ngo: "ngo",
      mui: "mui",
      than: "than",
      dau: "dau",
      tuat: "tuat",
      hoi: "hoi",
    };

    const useRedIcon = isSunday || hasEvents;
    const isBlueIcon = isEvenPage;

    return (
      <div className="mt-2 flex items-center">
        {keys.map((key, idx) => {
          const normalizedKey = ZODIAC_IMAGE_KEY_MAP[key] || key;

          const imageKey = useRedIcon
            ? `${normalizedKey}red`
            : isBlueIcon
              ? `${normalizedKey}blue`
              : normalizedKey;

          const src = (IMAGES as any)[imageKey];

          const fallbackSrc = (IMAGES as any)[normalizedKey];

          if (!src && !fallbackSrc) return null;

          return (
            <img
              key={`${key}-${idx}`}
              src={src || fallbackSrc}
              alt={String(key)}
              className="w-[50px] h-[50px] object-contain mr-2 shrink-0"
              style={{
                imageRendering: "crisp-edges",
                WebkitBackfaceVisibility: "hidden",
                backfaceVisibility: "hidden",
                transform: "translateZ(0)",
              }}
            />
          );
        })}
      </div>
    );
  };
  return (
    <div
      className={`relative mx-auto overflow-hidden border border-[#c9b79c] bg-white shadow-md leading-[1.2]   ${containerClass}`}
    >
      <div className="pointer-events-none absolute top-1/2 left-1/2 flex -translate-x-1/2 -translate-y-1/2 justify-center opacity-50">
        <img src={IMAGES.logoPT} alt="" className={logoClass} />
      </div>

      <div className="relative z-10 leading-[1.2]">
        <div className="flex justify-between w-full">
          <div className={`font-medium text-[#A62A26] uppercase ${introClass}`}>
            Phong thuỷ Đại Nam - Vạn sự niên {detailCalendar?.yearSolar}
          </div>
          <div className={`font-medium text-[#A62A26] uppercase ${introClass}`}>
            Vì cuộc sống An lạc - Thịnh vượng
          </div>
        </div>
        {/* <div className="flex justify-center items-center mt-3">
          <img
            src={IMAGES.headerLogo}
            alt="Phong Thủy Đại Nam"
            className="h-full w-[200px]  object-contain"
          />
        </div> */}
        <div className={titleWrapClass}>
          <h1
            className={`font-bold uppercase tracking-wide text-[#A98137] ${titleClass}`}
          >
            <h1
              className={`font-bold uppercase tracking-wide text-[#A98137] ${titleClass}`}
            >
              {title}
            </h1>
          </h1>
        </div>
      </div>

      <div className={bodyWrapClass}>
        {detailCalendar?.items?.map((item: any, index: number) => {
          const { day, month, year } = extractDMY(item?.dateSolar);
          const isEvenPage = index % 2 === 1; // page 2 (index 1) should be red
          const isSunday = item?.weekday === "chu_nhat";
          const hasEvents = !!item?.events?.length;
          const accentColor =
            hasEvents || isSunday
              ? "#C62627"
              : isEvenPage
                ? "#1e3a8a "
                : "#266914";
          return (
            <div
              className={boxClass(isEvenPage, isSunday, hasEvents)}
              key={index}
            >
              <div
                className={
                  exportMode
                    ? "grid grid-cols-4 items-stretch"
                    : "grid grid-cols-1 md:grid-cols-5 items-stretch"
                }
              >
                <div
                  className={`p-3 pb-0 col-span-1 h-full flex items-center justify-center`}
                >
                  <div className="w-[150px] h-full bg-white flex flex-col relative">
                    <div
                      style={{
                        backgroundColor: accentColor,
                        borderColor: accentColor,
                      }}
                      className="py-1 border text-center text-sm font-extrabold uppercase tracking-wide text-white"
                    >
                      {mapArrayWithObject([item?.weekday], WEEKDAY_MAPPING) ||
                        "---"}
                    </div>

                    <div
                      style={{
                        clipPath:
                          "polygon(0 0, 100% 0, 100% calc(100% - 10px), calc(100% - 10px) 100%, 0 100%)",
                      }}
                      className="relative flex flex-col items-center justify-center bg-white p-2 border border-[#C1AC96] flex-1 overflow-hidden"
                    >
                      {/* Solar date */}
                      <div
                        className="text-7xl font-bold leading-none flex items-center justify-center flex-1"
                        style={{ color: accentColor }}
                      >
                        {day || "---"}
                      </div>

                      {/* Divider */}
                      <div
                        className="border w-full my-1"
                        style={{ borderColor: accentColor }}
                      ></div>

                      {/* Bottom content */}
                      <div className="flex flex-col items-center gap-1 pb-1">
                        <div
                          className="text-sm font-semibold"
                          style={{ color: accentColor }}
                        >
                          {month && year ? `${month}/${year}` : "---"}
                        </div>

                        {/* Lunar */}
                        <div className="text-xs text-[#000000] font-normal text-center leading-tight">
                          {item?.dateLunar || "---"} Âm Lịch
                        </div>
                        <div className="text-xs text-[#C62627] font-medium text-center leading-tight">
                          {item?.events?.map((event: any) => (
                            <div key={event._id}>{event?.name}</div>
                          ))}
                        </div>
                      </div>

                      {/* Border góc cắt */}
                      <div className="absolute bottom-[3px] right-[-2px] w-[14px] border-t border-[#C1AC96] rotate-[-45deg]" />
                    </div>
                  </div>
                </div>

                <div
                  className={`${mediumTextClass} col-span-4 border-b ${borderColor} h-full`}
                >
                  <div className="grid grid-cols-2 auto-rows-fr">
                    <div className={`grid-cols-2 grid`}>
                      <div
                        className={
                          exportMode
                            ? `border-r ${borderColor} p-3 md:p-4`
                            : `border-b md:border-b-0 md:border-r ${borderColor} p-3 md:p-4 `
                        }
                      >
                        Ngày:{" "}
                        <span className="font-bold">
                          {" "}
                          {mapArrayWithObject(
                            [
                              `${item?.ngayCan || "---"}_${item?.ngayChi || "---"}`,
                            ],
                            CAN_CHI,
                          ) || "---"}
                        </span>
                      </div>
                      <div
                        className={
                          exportMode
                            ? `border-r ${borderColor} p-3 md:p-4`
                            : `border-b md:border-b-0 md:border-r ${borderColor} p-3 md:p-4 `
                        }
                      >
                        Giờ:{" "}
                        <span className="font-bold">
                          {" "}
                          {mapArrayWithObject(
                            [`${item?.gio || "---"}`],
                            CAN_CHI,
                          ) || "---"}
                        </span>
                      </div>
                    </div>

                    <div
                      className={`p-3 md:p-4 border-b md:border-b-0 ${borderColor} `}
                    >
                      Hành:{" "}
                      <span className="font-bold">
                        {" "}
                        {mapArrayWithObject([item?.nguHanhNgay], NGU_HANH) ||
                          "---"}
                      </span>{" "}
                      - Tú:{" "}
                      <span className="font-bold">
                        {" "}
                        {mapArrayWithObject([item?.tu], TU) || "---"}
                      </span>{" "}
                      - Trực:{" "}
                      <span className="font-bold">
                        {" "}
                        {mapArrayWithObject([item?.truc], TRUC) || "---"}
                      </span>
                    </div>
                  </div>

                  <div
                    className={`grid grid-cols-2 auto-rows-fr ${borderColor} md:border-t`}
                  >
                    <div className={`grid-cols-2 grid`}>
                      <div
                        className={
                          exportMode
                            ? `border-r ${borderColor}  p-3 md:p-4`
                            : ` md:border-b-0 border-r ${borderColor}   p-3 md:p-4`
                        }
                      >
                        Ngày:{" "}
                        <span className="font-bold ">
                          {" "}
                          {mapArrayWithObject(
                            [item?.hoangDaoHacDaoType],
                            NGAY_HOANGDAO_HACDAO_MAPPING,
                          ) || "---"}
                        </span>
                      </div>
                      <div
                        style={{
                          color: accentColor,
                        }}
                        className={
                          exportMode
                            ? `border-r ${borderColor}  p-3 md:p-4 flex  gap-2 items-start`
                            : `border-r ${borderColor}  p-3 md:p-4 flex  gap-2 items-start`
                        }
                      >
                        <span> Tiết: </span>
                        <div className="flex flex-col ">
                          <span
                            style={{
                              color: accentColor,
                            }}
                            className="font-semibold "
                          >
                            {mapArrayWithObject(
                              [item?.tiet || "---"],
                              TIET_KHI,
                            ) || "---"}{" "}
                          </span>
                          <p className="">
                            {" "}
                            {item?.tietKhiTime && `(${item.tietKhiTime})`}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div
                      className={exportMode ? `  p-3 md:p-4` : ` p-3 md:p-4 `}
                    >
                      Bách kỵ:{" "}
                      {item?.bachKy?.map((day: any, idx: any) => (
                        <span className="font-bold" key={idx}>
                          {mapArrayWithObject([day], BACH_KY)}
                          {idx < item.bachKy.length - 1 ? ", " : ""}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div
                    className={`grid grid-cols-2 auto-rows-fr ${borderColor} border-t`}
                  >
                    <div className={`grid-cols-2 grid`}>
                      <div
                        className={
                          exportMode
                            ? `border-r ${borderColor}  p-3 md:p-4`
                            : `border-r ${borderColor}  p-3 md:p-4`
                        }
                      >
                        <div className="flex items-center gap-2">
                          {isSunday || hasEvents ? (
                            <img
                              className="w-10 h-10 object-contain"
                              src={IMAGES.sunrisered}
                              alt="icon-err"
                            />
                          ) : isEvenPage ? (
                            <SunRiseIcon className="w-10 h-10 object-contain text-blue-900" />
                          ) : (
                            <SunRiseIcon className="w-10 h-10 object-contain text-[#266914]" />
                          )}
                          <div className="flex flex-col gap-1">
                            <p className="font-normal">Mặt trời mọc: </p>
                            <span className="font-bold">
                              {item?.sun?.sunrise || "---"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          exportMode
                            ? `border-r ${borderColor}  p-3 md:p-4`
                            : `border-r ${borderColor}  p-3 md:p-4`
                        }
                      >
                        <div className="flex items-center gap-2">
                          {hasEvents || isSunday ? (
                            <img
                              className="w-10 h-10 object-contain"
                              src={IMAGES.sunlunchred}
                              alt="sun-lunch-icon"
                            />
                          ) : isEvenPage ? (
                            <SunLunchIcon className="w-10 h-10 object-contain text-blue-900" />
                          ) : (
                            <SunLunchIcon className="w-10 h-10 object-contain text-[#266914]" />
                          )}

                          <div className="flex flex-col gap-1">
                            <p className="font-normal">Giữa trưa: </p>
                            <span className="font-bold">
                              {item?.sun?.noon || "---"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className={exportMode ? `  p-3 md:p-4` : ` p-3 md:p-4`}
                    >
                      <div className="flex items-center gap-2">
                        {isSunday || hasEvents ? (
                          <img
                            className="w-10 h-10 object-contain"
                            src={IMAGES.sunsetred}
                            alt="sunset-icon"
                          />
                        ) : isEvenPage ? (
                          <SunSetIcon className="w-10 h-10 object-contain text-blue-900" />
                        ) : (
                          <SunSetIcon className="w-10 h-10 object-contain text-[#266914]" />
                        )}
                        <div className="flex flex-col gap-1">
                          <p className="font-normal"> Mặt trời lặn: </p>
                          <span className="font-bold">
                            {item?.sun?.sunset || "---"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Row
                className={
                  exportMode
                    ? `grid grid-cols-2 text-lg `
                    : `grid grid-cols-1 text-sm sm:text-base md:grid-cols-2 md:text-lg`
                }
              >
                <div className={`flex flex-col md:border-r ${borderColor}`}>
                  <div
                    className={
                      exportMode
                        ? `grid grid-cols-2 text-lg`
                        : `grid grid-cols-1 text-sm sm:text-base md:grid-cols-2 md:text-lg  `
                    }
                  >
                    <div
                      className={
                        exportMode
                          ? `border-r ${borderColor} p-3 md:p-4`
                          : `border-b md:border-b-0 md:border-r ${borderColor} p-3 md:p-4 `
                      }
                    >
                      <span
                        className="font-semibold"
                        style={{ color: accentColor }}
                      >
                        Nhị hợp:
                      </span>{" "}
                      {mapArrayWithObject(item?.nhiHop, CAN_CHI) || "---"}
                    </div>

                    <div className="p-3 md:p-4">
                      <span
                        className="font-semibold"
                        style={{ color: accentColor }}
                      >
                        Tam hợp:
                      </span>{" "}
                      {mapArrayWithObject(item?.tamHop, CAN_CHI) || "---"}
                    </div>
                  </div>
                  <div className={`border-t ${borderColor}`}>
                    <Cell>
                      <div>
                        <div className="">
                          <span
                            style={{ color: accentColor }}
                            className="font-semibold"
                          >
                            Tuổi xung với ngày:
                          </span>{" "}
                          {item?.tuoiXungNgay?.map((day: any, idx: number) => (
                            <span key={idx}>
                              {mapArrayWithObject([day.key], CAN_CHI) || "---"}
                              {idx < item.tuoiXungNgay?.length - 1 && ", "}
                            </span>
                          ))}
                        </div>

                        <div className="">
                          <span
                            style={{ color: accentColor }}
                            className="font-semibold"
                          >
                            Tuổi xung với tháng:
                          </span>{" "}
                          {item?.tuoiXungThang?.map((day: any, idx: number) => (
                            <span key={idx}>
                              {mapArrayWithObject([day.key], CAN_CHI) || "---"}
                              {idx < item.tuoiXungThang.length - 1 && ", "}
                            </span>
                          ))}
                        </div>
                      </div>
                    </Cell>
                  </div>
                </div>

                <div
                  className={
                    exportMode
                      ? "grid grid-cols-2 text-lg"
                      : "grid grid-cols-1 text-sm sm:text-base md:grid-cols-2 md:text-lg"
                  }
                >
                  <div
                    className={
                      exportMode
                        ? `border-r ${borderColor} p-3 md:p-4 flex items-center flex-col gap-2`
                        : `border-b md:border-b-0 md:border-r ${borderColor} p-3 md:p-4`
                    }
                  >
                    <div className="flex items-start md:items-center flex-col gap-2">
                      <div>
                        <span className="font-semibold">Hình: </span>{" "}
                        {mapArrayWithObject(item?.chiHinh, CAN_CHI) || "---"}
                      </div>
                      {renderZodiacIcons(
                        item?.chiHinh,
                        index % 2 === 1,
                        item?.events?.length > 0,
                        item?.weekday === "chu_nhat",
                      )}
                    </div>
                  </div>
                  <div className="p-3 md:p-4 flex items-start md:items-center flex-col gap-2">
                    <div className="flex flex-col items-center gap-2">
                      <div>
                        <span className="font-semibold">Hại: </span>{" "}
                        {mapArrayWithObject([item?.chiHai], CAN_CHI) || "---"}
                      </div>
                    </div>
                    {renderZodiacIcons(
                      item?.chiHai,
                      index % 2 === 1,
                      item?.events?.length > 0,
                      item?.weekday === "chu_nhat",
                    )}
                  </div>
                </div>
              </Row>

              <Row
                className={
                  exportMode
                    ? "grid grid-cols-2 text-lg"
                    : "grid grid-cols-1 text-sm sm:text-base md:grid-cols-2 md:text-lg"
                }
              >
                <div
                  className={
                    exportMode
                      ? `border-r ${borderColor}`
                      : `border-b md:border-b-0 md:border-r ${borderColor}`
                  }
                >
                  <Cell className={smallTextClass}>
                    <div className="mb-1 flex flex-wrap">
                      <span
                        className="font-semibold"
                        style={{ color: accentColor }}
                      >
                        Sao tốt:{" "}
                        <span className="text-[#1A1A1A] font-normal">
                          {" "}
                          {mapArrayWithObject(item.saoTot, SAO_TOT)}
                        </span>
                      </span>{" "}
                    </div>

                    <div className="">
                      <span
                        className="font-semibold"
                        style={{ color: accentColor }}
                      >
                        Sao xấu:{" "}
                        <span className="text-[#1A1A1A] font-normal">
                          {" "}
                          {mapArrayWithObject(item.saoXau, SAO_XAU)}
                        </span>
                      </span>{" "}
                    </div>
                  </Cell>
                </div>

                <div
                  className={
                    exportMode
                      ? "grid grid-cols-2 text-lg"
                      : "grid grid-cols-1 text-sm sm:text-base md:grid-cols-2 md:text-lg"
                  }
                >
                  <Cell
                    className={
                      exportMode
                        ? `border-r ${borderColor}`
                        : `border-b md:border-b-0 md:border-r ${borderColor}`
                    }
                  >
                    <span
                      className="font-semibold"
                      style={{ color: accentColor }}
                    >
                      Giờ tốt:
                    </span>{" "}
                    {mapArrayWithObject(item?.gioTot, CAN_CHI) || "---"}
                  </Cell>
                  <Cell>
                    <span
                      className="font-semibold"
                      style={{ color: accentColor }}
                    >
                      Giờ xấu:
                    </span>{" "}
                    {mapArrayWithObject(item?.gioXau, CAN_CHI) || "---"}
                  </Cell>
                </div>
              </Row>

              <div
                className={
                  exportMode
                    ? "grid grid-cols-2 text-lg"
                    : "grid grid-cols-1 text-sm sm:text-base md:grid-cols-2 md:text-lg"
                }
              >
                <Cell
                  className={
                    exportMode
                      ? `border-r ${borderColor} flex flex-col gap-2`
                      : `border-b md:border-b-0 md:border-r ${borderColor}`
                  }
                >
                  <div className="flex items-start gap-2">
                    {isSunday || hasEvents ? (
                      <img
                        src={IMAGES.shoulddored}
                        alt="should-do-icon"
                        className="w-10 h-10  object-contain"
                      />
                    ) : isEvenPage ? (
                      <img
                        src={IMAGES.shoulddoblue}
                        alt="should-do-icon"
                        className="w-10 h-10  object-contain"
                      />
                    ) : (
                      <img
                        src={IMAGES.shouddo}
                        alt="should-do-icon"
                        className="w-10 h-10  object-contain"
                      />
                    )}
                    <div className="flex flex-col gap-1">
                      <span
                        className="font-semibold "
                        style={{ color: accentColor }}
                      >
                        ĐIỀU NÊN LÀM:
                      </span>{" "}
                      <p>
                        {mapArrayWithObject(item.nen, CONG_VIEC_MAPPING)
                          ?.toLowerCase()
                          ?.replace(/^./, (s) => s.toUpperCase())}
                      </p>
                    </div>
                  </div>
                </Cell>
                <Cell className="flex flex-col gap-2">
                  <div className="flex items-start gap-2">
                    <img
                      src={IMAGES.limit}
                      alt="limit-icon"
                      className="w-10 h-10  object-contain"
                    />
                    <div className="flex flex-col gap-1">
                      <span className="font-semibold uppercase text-[#000000]">
                        Hạn chế thực hiện các việc:
                      </span>{" "}
                      {mapArrayWithObject(item.khongNen, CONG_VIEC_MAPPING)
                        ?.toLowerCase()
                        ?.replace(/^./, (s) => s.toUpperCase())}
                    </div>
                  </div>
                </Cell>
              </div>
            </div>
          );
        })}

        <div className={`${quoteClass} ${primaryText} leading-[1.2]`}>
          {detailCalendar?.folkPoetry
            ?.split(/\n|\|/)
            .filter(Boolean)
            .map((line: string, index: number) => (
              <div key={index}>{line.trim()}</div>
            ))}
        </div>
      </div>
    </div>
  );
}
